import { QueryClient } from '@tanstack/react-query';

// Single QueryClient instance. Lifted out of App.tsx so non-component code
// (the tenant store) can call `queryClient.clear()` on tenant switch without
// pulling App.tsx into the import graph.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 5,
      retry: false,
    },
  },
});
